<template>
  <div>
    <el-form-item label="提示文字">
      <el-input size="small" v-model="value.placeholder[0]" placeholder="开始日期提示"/>
      <el-input size="small" v-model="value.placeholder[1]" placeholder="结束日期提示"/>
    </el-form-item>
    <el-form-item label="日期格式">
      <el-select size="small" v-model="value.format" class="width-100">
        <!-- <el-option value="yyyy" label="年"></el-option>
        <el-option value="yyyy-MM" label="年-月"></el-option> -->
        <el-option value="yyyy-MM-dd" label="年-月-日"></el-option>
        <!-- <el-option value="yyyy-MM-dd HH:mm" label="年-月-日 时:分"></el-option> -->
        <el-option value="yyyy-MM-dd HH:mm:ss" label="年-月-日 时:分:秒"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="累计时间" class="radio-group-total">
      <el-radio-group v-model="value.totalType">
          <el-radio label="none"><span class="name-text">不显示</span></el-radio>
          <el-radio label="day"><span class="name-text">统计天数</span></el-radio>
          <el-radio label="hour"><span class="name-text">统计小时</span></el-radio>
        </el-radio-group>
    </el-form-item>
    <!-- <el-form-item label="展示时长">
      <el-switch v-model="value.showLength"></el-switch>
    </el-form-item> -->
  </div>
</template>

<script>
export default {
  name: "DateTimeRangeConfig",
  components: {},
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>
.width-100{
  width: 100%;
}
.radio-group-total /deep/ .el-radio{
  display: block;
  line-height: 28px;
}
</style>

